import { render } from "./Recetas.vue?vue&type=template&id=f261cdec"
import script from "./Recetas.vue?vue&type=script&lang=js"
export * from "./Recetas.vue?vue&type=script&lang=js"
script.render = render

export default script